module.exports = __webpack_public_path__ + "img/envelope-2.fd3ca7af.svg";